import Vue from 'vue'
import Vuex from 'vuex'
import { Auth } from 'aws-amplify'
import axiosWithInterceptor from '@/services/interceptor'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    user: {
      _id: '',
      email: '',
      profile: {
        firstName: '',
        lastName: '',
        phone: '',
        cpf: ''
      },
      documents: {},
      isActive: false,
      createdAt: '',
      bankAccount: {
        type: '',
        accountDigit: '',
        accountNumber: '',
        branchNumber: '',
        bankID: '',
        bank: {
          _id: '',
          code: '',
          name: '',
          site: ''
        },
        holder: {
          name: '',
          email: '',
          cpf: ''
        }
      },
      config: {
        withDraw: {
          isFree: false,
          tax: 0.0
        },
        defaultListId: '',
        access: ''
      }
    },
    lists: [],
    orders: [],
    ordersAmount: 0
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    user: state => state.user,
    lists: state => state.lists,
    orders: state => state.orders,
    ordersAmount: state => state.ordersAmount
  },
  mutations: {
    setIsAuthenticated (state, isAuthenticated) { state.isAuthenticated = isAuthenticated },
    setUser (state, user) { state.user = user },
    setOrders (state, orders) { state.orders = orders },
    setOrdersAmount (state, amount) { state.ordersAmount = amount },
    setLists (state, lists) { state.lists = lists }
  },
  actions: {
    setIsAuthenticated ({ commit }, isAuthenticated: boolean) {
      Auth.currentAuthenticatedUser().then(currentUser => {
        const token = currentUser.signInUserSession?.accessToken?.jwtToken || ''

        localStorage.setItem('currentUser', JSON.stringify({ token }))

        axiosWithInterceptor.SetHeaderToken(token)

        this.dispatch('getUser')

        commit('setIsAuthenticated', isAuthenticated)
      })
    },
    getUser ({ commit }, user: any) {
      axiosWithInterceptor.instance.get('user/me')
        .then(res => commit('setUser', { ...res.data }))
        .catch(err => console.log(err))
    },
    getLists ({ commit }, user: any) {
      axiosWithInterceptor.instance.get('list/all')
        .then(res => commit('setLists', { ...res.data }))
        .catch(err => console.log(err))
    },
    getOrders ({ commit }, orders: any) {
      axiosWithInterceptor.instance.get('order')
        .then((res: any) => {
          commit('setOrders', res.data)

          let ordersAmount = 0
          res.data.forEach((order: any) => {
            ordersAmount += order.amount
          })

          if (ordersAmount > 0) {
            commit('setOrdersAmount', ordersAmount)
          }
        })
        .catch((err: any) => console.log(err))
    }
  },
  modules: {}
})
